import { render } from "./SnapshotProposalBox.vue?vue&type=template&id=704ee602&scoped=true"
import script from "./SnapshotProposalBox.vue?vue&type=script&lang=js"
export * from "./SnapshotProposalBox.vue?vue&type=script&lang=js"

import "./SnapshotProposalBox.vue?vue&type=style&index=0&id=704ee602&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-704ee602"]])

export default __exports__